// ----------------------------------------------------------------------
// <copyright file="Izenda.CopyManagement.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
  * @module CopyManagement component
  */
!function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var WorkspaceDetail = require('./WorkspaceDetail/Izenda.WorkspaceDetail');
  var WorkspaceList = require('./WorkspaceList/Izenda.WorkspaceList');

  var MiddlePanel = require('share/components/layout/Izenda.MiddlePanel');

  var WorkspaceStore = require('logic/Izenda.WorkspaceStore');
  var WorkspaceDetailStore = require('logic/Izenda.WorkspaceDetailStore');

  var CopyManagement = React.createClass({
    componentWillMount: function(){
      this.workspaceStore = new WorkspaceStore();
      this.workspaceDetailStore = new WorkspaceDetailStore(this.workspaceStore);
    },

    componentDidMount: function () {
      var loader = this.props.loader;
      loader.startLoading();
      this.workspaceStore.loadList().finally(loader.endLoading.bind(loader));
    },

    componentWillUnmount: function () {
      this.workspaceStore.dispose();
    },

    render: function () {
      return (
        <section className='izenda-CopyManagement izenda-TableLayout'>

          <MiddlePanel>
            <WorkspaceList store={this.workspaceStore} />
          </MiddlePanel>

          <div className="izenda-TableLayout-Cell">
            <WorkspaceDetail
              store={this.workspaceDetailStore}
              item={this.workspaceDetailStore.item} />
          </div>

        </section>
      );
    }
  });

  module.exports = connect()(CopyManagement);
}();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/Izenda.CopyManagement.jsx